export default function formatDate(dateString){
    // Parse the date string into a Date object
    const date = new Date(dateString);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
        return "Invalid date";
    }
    
    // Create options for formatting
    const options = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };

    // Format the date
    return date.toLocaleString('en-GB', options); // 'en-GB' for formatting like "5 Sep 2024, 11:21 AM"
}
